import cheer from "../audio/cheer.mp3"
import drop from "../audio/drop.mp3"
import error from "../audio/error.mp3"
import flip from "../audio/flip.mp3"
import match from "../audio/match.mp3"
import shuffle from "../audio/shuffle.mp3"

const audios = {
  cheer,
  drop,
  error,
  flip,
  match,
  shuffle,
}

const POOL_SIZE = 3
const pools = {}

function isBrowser() {
  return typeof window !== "undefined" && typeof Audio !== "undefined"
}

function createPool(sound) {
  if (!isBrowser() || !audios[sound]) {
    return []
  }

  return Array.from({ length: POOL_SIZE }, () => {
    const audio = new Audio(audios[sound])
    audio.preload = "auto"
    audio.load()
    return audio
  })
}

function getPool(sound) {
  if (!pools[sound]) {
    pools[sound] = createPool(sound)
  }

  return pools[sound]
}

function playFromPool(sound) {
  const pool = getPool(sound)
  if (pool.length === 0) {
    return
  }

  const audio = pool.shift()
  pool.push(audio)

  try {
    audio.pause()
    audio.currentTime = 0
    const playPromise = audio.play()
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {})
    }
  } catch (_) {
    // Ignore Safari/autoplay timing errors and keep the pool reusable.
  }
}

function result(sound) {
  playFromPool(sound)
}

function play(sound) {
  playFromPool(sound)
}

const audio = {
  play,
  result,
}

export default audio
